import SearchComp from "components/Searchcomponent";
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DirectoryTable } from './DirectoryTable/DirectoryTable';
import { ClearFilterButton, ClearFilterWrapper, DirectoryHeader, SearchWrapper, Title } from './Theme';

export const Directory = () => {
  const { search, pathname } = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(search);
  const accountIdParams = searchParams.get("accountId");


    const initialFilters = {
        sort: {},
        // filter: {
        //   "hidden": true,
        // },
        search: undefined,
      };
      const [page, setPage] = useState(0)

    const [searchValue, setSearchValue] = React.useState("");
    const [filters, setFilters] = useState(initialFilters);
    const { push } = useHistory();
    const  memberPortalDirectoryPermission=  JSON.parse(localStorage.getItem("memberPortalDirectory"))

    const sortCharged = (e) => {
      setFilters((prev) => ({
        ...prev,
        sort: {
          [e]: prev.sort[e] === 1 ? -1 : 1,
        },
      }));
    };
    const onSearchChange = (e) => {
      const name = e.target.value;
      setPage(0)
      setFilters((prev) => ({
        ...prev,
        search: name ? name : undefined,
      }));
      resetSearchParams();
    };
      useEffect(() => {
        setFilters((prev) => ({
          ...prev,
          search: searchValue ? searchValue : undefined,
        }));
      }, [searchValue]);

      useEffect(()=>{
        if(!memberPortalDirectoryPermission){
          push("/family-member-table")
        }
        
      },[memberPortalDirectoryPermission])


  const resetSearchParams = () => {
    history.push({
      pathname,
      search: '', 
    });
  }

  const filterFamilyHandler = (link) => {
    setFilters((prev) => ({
      ...prev,
      search: undefined,
    }));
    setPage(0)
    history.push(link);
  }

  return (
      <div className="school-classes w-100">
        <div className="filteration d-flex align-items-center" style={{ marginBottom: 12, flexWrap: "wrap" }}>
          <SearchWrapper>
            <SearchComp
              value={filters?.search ? filters?.search : ""}
              setSearchText={onSearchChange}
              placeholder="Search by first name, last name"
              style={{background: '#ffff'}}
            />
          </SearchWrapper>
          {accountIdParams && (
            <ClearFilterWrapper>
              Filtered By Family Name
              <ClearFilterButton onClick={resetSearchParams}>
                Clear Filter
              </ClearFilterButton>
            </ClearFilterWrapper>
          )}
        </div>
        <div className="charges-table w-100">
          <DirectoryTable filters={filters}  sortCharged={sortCharged} page={page} setPage={setPage} accountIdParams={accountIdParams} filterFamilyHandler={filterFamilyHandler}/>
          </div>
      </div>
  );
};

